import React, { FormEvent } from 'react';
import styles from './RegistrationPageLayout.module.scss';
import LogoIcon from 'src/assets/img/logo.svg?react'
import Button from '../button/Button';
import { NavLink } from 'react-router-dom';

type Common = {
  children: React.ReactNode | any;
  title: React.ReactNode;
  loading: boolean;
  buttonTitle: string;
  onSubmit: (e: FormEvent) => void;
  registrationSuccessful?: boolean;
}

type WithRender = {
  children: () => React.ReactNode;
}

type Props = Common | WithRender;

function RegistrationPageLayout(props: Props) {
  const { children } = props;
  const { loading, registrationSuccessful, onSubmit } = props as Common;

  return (
    <div className={styles.registerPage}>
      <div className={styles.backBlur}></div>
      <div className={styles.pageBody}>
        {/* {<LogoIcon className={styles.logo} />}
        <h1 className={styles.registerTitle}>Teach Mental Health skills using Authentic Peer voices.</h1> */}
        <div>
          <div className={styles.logo}></div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.rightBigContent} >
            {typeof children === 'function' ? children() :
              <form className={styles.formClass} onSubmit={onSubmit}>
                {children}
              </form>
            }
            {!registrationSuccessful && <Button
              disabled={loading}
              className={styles.registerButton}
              label={"Register"}
              isLoading={loading}
              type={"submit"}
              onClick={onSubmit}
            />}
          </div>
        </div>
        <div className={styles.back}>
          Already have an account? &nbsp;
          <NavLink className={styles.backLink} to={"/login"}>
            Login
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default RegistrationPageLayout;
